// components/molecules/Diagram/Diagram.js
import PropTypes from 'prop-types';

const Diagram = ({ value }) => {
  if (!value?.url) return null;

  return (
    <section className="section section-default-width">
      <div className="section__inner">
        <div className="section__body">
          <div className="block">
            <div className="block__body">
              <div className="media">
                <img
                  src={value.url}
                  alt={value.title || 'Diagram'}
                  className="w-full h-auto"
                />
              </div>
              {value.caption && (
                <div className="text-body-sm text-neutral-600 mt-sm">{value.caption}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Diagram.propTypes = {
  value: PropTypes.shape({
    url:     PropTypes.string.isRequired,
    title:   PropTypes.string,
    caption: PropTypes.string,
  }),
};

Diagram.defaultProps = { value: null };

export default Diagram;